import { render, staticRenderFns } from "./DetailSurveyFormSystem.vue?vue&type=template&id=9240e7c2&scoped=true"
import script from "./DetailSurveyFormSystem.vue?vue&type=script&lang=js"
export * from "./DetailSurveyFormSystem.vue?vue&type=script&lang=js"
import style0 from "./DetailSurveyFormSystem.vue?vue&type=style&index=0&id=9240e7c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9240e7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9240e7c2')) {
      api.createRecord('9240e7c2', component.options)
    } else {
      api.reload('9240e7c2', component.options)
    }
    module.hot.accept("./DetailSurveyFormSystem.vue?vue&type=template&id=9240e7c2&scoped=true", function () {
      api.rerender('9240e7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SurveyForm/dialog/DetailSurveyFormSystem.vue"
export default component.exports